// import { LogoStrokedGradient } from 'assets/icons';
import type { CSSProperties } from 'react';
import { Container } from '..';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import Cake from '../../assets/cake-icon.svg';
import Image from 'next/image';
import styles from './HeroSection.module.css';

export const HeroSection = ({
  className,
  name,
  title,
  subtitle,
  discountInfo,
}: {
  className?: string;
  name: string;
  title?: string;
  subtitle?: string;
  discountInfo?: { dateRange: string | null; percentage: number } | null;
}) => {
  const heroStyle = {
    '--hero-bg-mobile': `url(${getCompressedAssetUrl(
      '/web_v2/birthday/hero_bg/bg_updated_mobile.png/w_900',
    )})`,
    '--hero-bg-desktop': `url(${getCompressedAssetUrl(
      '/web_v2/birthday/hero_bg/bg_updated.png/w_1920',
    )})`,
  } as CSSProperties;

  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
      style={heroStyle}
    >
      <div className={styles.noiseBg} aria-hidden="true"></div>
      <Container className={styles.content}>
        {/* <LogoStrokedGradient className="uh-logo" /> */}
        <p className={styles.discountExpiryInfo}>
          {discountInfo && (
            <>
              {discountInfo.percentage}% off{' '}
              <span className="cake">
                <Image src={Cake} alt="cake_icon" />
              </span>{' '}
              {discountInfo.dateRange}
            </>
          )}
        </p>
        <h1>
          {title || 'Happy Birthday'}
          {name ? <>{`, ${name}`}!</> : null}
        </h1>

        <p className={styles.subtitle}>
          {subtitle ||
            'Celebrate with exclusive Ultrahuman offers just for you'}
        </p>
      </Container>
    </section>
  );
};
